import React from 'react';

import { useEffect, useState } from 'react';

import { Footer as ADSFooter } from '@artegeie/design-system/corporate'

import useAPI from 'Hooks/useAPI';

const Footer = () => {

	const API = useAPI();
	const [ footerItems, setFooterItems ] = useState( [] );

	useEffect(() => {
		API.fetchFooterItems()
		.then(data => {
			setFooterItems( data );
		} );
		}, [ API ]
	);

	return (
		<ADSFooter
			footerItems={ footerItems }
			newsletterRegisterUrl="https://api.arte.tv/api/sso/v3/newsletter/subscribe"
			newsletterSource="presse_footer"
		/>
	);
};

export default Footer;
